<template>

  <!----------- videos ---------------------------------->
  <div class="column is-12">
    <div class="box">
      <div class="columns">
        <div class="column is-12">
          <label class="label">{{ elLabel }}</label>
          <div class="field has-addons">
            <div class="control is-expanded">
              <input
              class="input"
              v-model="video"
              placeholder="Youtube-Video ID">
            </div>
            <div class="control">
              <a class="button is-info" v-if="video.length" @click="addVideo">
                Hinzufügen
              </a>
            </div>
          </div>
        </div>
      </div>

      <draggable v-model="n" :options="{draggable:'.column', handle:'.my-handle'}" class="columns is-multiline">
        <div class="column is-3" v-for="(i, index) in n" :key="index">

          <div class="card card-equal-height">
                  <header class="card-header">
                <a class="is-pulled-right icon my-handle">
                  <i class="fa fa-arrows"></i>
                </a>
            </header>
            <div class="card-image">
              <div class="videowrapper" style="margin-top:0; margin-bottom:0;"><iframe width="100%" height="auto" :src="'https://www.youtube-nocookie.com/embed/' + i" frameborder="0" allowfullscreen></iframe>
              </div>
              <footer class="card-footer">
                <a class="card-footer-item" @click="$emit('videoWasDeleted', index)">Löschen</a>
              </footer>
            </div>


          </div>
        </div>
      </draggable>
    </div>
  </div>

</template>

<script>
import draggable from 'vuedraggable'
export default {
  inject: ['$validator'],
  props: ['data', 'elLabel'],
  data () {
    return {
      video: ''
    }
  },
  methods: {
    addVideo () {
      this.$emit('videoWasAdded', this.video)
      this.video = ''
    }
  },
  computed: {
    n: {
      get () {
        return this.data
      },
      set (value) {
        this.$emit('wasSorted', value)
      }
    }
  },
  components: {
    draggable
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/cms/elements/Videos.vue